import { constants, utils } from '@kingpin-global/kingpin-utils-frontend'

import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect' // eslint-disable-line
import { Settings } from '@/Settings'
import mixpanelTracks from './mixpanel-tracks'

const { ORDER_PRODUCT_STATUS_COLOR_CODE } = utils

const { COLLECTION_STATUS, KP_MONTH_FORMAT, CURRENCY_CONVERSIONS } = constants

const ORDER_PRODUCT_SHIPMENT_STATUS = {
  ...constants.ORDER_PRODUCT_SHIPMENT_STATUS,
  // one more constant for selected products
  SELECTED_BY_USER: {
    LABEL: 'selectedByUser',
    TEXT: constants.ORDER_PRODUCT_SHIPMENT_STATUS.READY_TO_SHIP.TEXT,
  },
  PARTIALLY_SHIPPED: {
    LABEL: 'partiallyShipped',
    TEXT: 'Partially Shipped',
  },
  // KP-4363: a line the brand confirmed while the rest of the order is still open
  CONFIRMED: {
    LABEL: 'confirmed',
    TEXT: 'Confirmed · Ready to Ship',
  },
  // KP-4363: a confirmed line whose catalogue product is still live (the order
  // detail sends confirmedShippableStatus = inProcess); display-only
  CONFIRMED_PROCESSING: {
    LABEL: 'confirmedProcessing',
    TEXT: 'Confirmed · Processing',
  },
}
export const PRODUCTS_LIMIT = 20
export const MAX_FILE_SIZE = 20 * 1024 * 1024 // 20MB in bytes
export const FILE_FORMATS = {
  CSV: 'csv',
  ZIP: 'zip',
  PDF: 'pdf',
  XLSX: 'xlsx',
  PPTX: 'pptx',
}

export const PROFILE_IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'gif']
export const MAX_PROFILE_IMAGE_SIZE = 10 * 1024 * 1024

export const ORDER_STATUS_LABELS = {
  ...constants.ORDER_STATUS_LABELS,
  modified: 'Modified',
  partially_confirmed: 'Partially Confirmed',
}

export const ORDERS_TEXT_BRAND = {
  ...constants.ORDERS_TEXT_BRAND,
  modified: 'Order Modified',
  partially_confirmed: 'Order Partially Confirmed',
}

export const ORDERS_TEXT_RETAILER = {
  ...constants.ORDERS_TEXT_RETAILER,
  modified: 'Order Modified',
  partially_confirmed: 'Order Partially Confirmed by Brand',
}

export default {
  ORDER_PRODUCT_STATUS_COLOR_CODE: {
    ...ORDER_PRODUCT_STATUS_COLOR_CODE().FRONTEND,
    [ORDER_PRODUCT_SHIPMENT_STATUS.SELECTED_BY_USER.LABEL]: '#16acd9',
    [ORDER_PRODUCT_SHIPMENT_STATUS.PARTIALLY_SHIPPED.LABEL]: '#92400e',
    [ORDER_PRODUCT_SHIPMENT_STATUS.CONFIRMED.LABEL]: '#1f9d55',
  },
  ORDER_PRODUCT_SHIPMENT_STATUS,

  ORDER_STATUS: {
    ...constants.ORDER_STATUS,
    MODIFIED: 'modified',
    PARTIALLY_CONFIRMED: 'partially_confirmed',
  },
  ORDER_STATUS_LABELS,
  CONNECTION_REQUEST_STATUS: constants.CONNECTION_REQUEST_STATUS,
  PAYMENT_METHODS: constants.PAYMENT_METHODS,
  DOWNLOAD_OPTIONS: {
    ORDER: [
      { text: 'CSV', value: 'csv' },
      // { text: 'Images(Zip)', value: 'zip' },
    ],
    WISHLIST: [
      { text: 'PDF', value: 'pdf', fileType: FILE_FORMATS.PDF },
      { text: 'Excel', value: 'xlsx', fileType: FILE_FORMATS.XLSX },
      {
        text: 'Order Form',
        value: 'sku',
        fileType: FILE_FORMATS.XLSX,
        params: { type: 'sku' },
      },
      {
        text: 'Order Form (without images)',
        value: 'sku_no_images',
        fileType: FILE_FORMATS.XLSX,
        params: { noImages: true, type: 'sku' },
      },
      { text: 'PPTX', value: 'pptx', fileType: FILE_FORMATS.PPTX },
    ],
    SHIPMENT: [
      { text: 'CSV', value: 'csv' },
      // { text: 'Images(Zip)', value: 'zip' },
    ],
    CART: [
      { text: 'Excel', value: 'xlsx', fileType: FILE_FORMATS.XLSX },
      { text: 'PDF', value: 'pdf', fileType: FILE_FORMATS.PDF },
      { text: 'PPTX', value: 'pptx', fileType: FILE_FORMATS.PPTX },
    ],
    CATALOG: {
      XLSX: 'Download Excel',
      // CSV: 'csv',
    },
    WISHLIST_EXPORT: {
      XLSX: 'Download Excel',
      PDF: 'pdf',
    },
  },
  TRACKS: mixpanelTracks,
}

export const DOWNLOAD_TYPES = {
  ORDER_EXPORT: {
    LABEL: 'Order Export',
    VALUE: 'orderExport',
  },
  COLLECTION_EXPORT: {
    LABEL: 'Collection Export',
    VALUE: 'collectionExport',
  },
  WISHLIST_EXPORT: {
    LABEL: 'Wishlist Export',
    VALUE: 'wishlistExport',
  },
  SELECTION_EXPORT: {
    LABEL: 'Wishlist Export',
    VALUE: 'selectionExport',
  },
  CART_EXPORT: {
    LABEL: 'Cart Export',
    VALUE: 'cartExport',
  },
  MULTIPLE_CART_EXPORT: {
    LABEL: 'Multiple Cart Export',
    VALUE: 'multipleCartExport',
  },
  AVAILABILITY_EXPORT: {
    LABEL: 'Availability Export',
    VALUE: 'availabilityExport',
  },
}

export const DOWNLOAD_FILE_STATUS = {
  PROCESSING: {
    LABEL: 'Processing',
    VALUE: 'processing',
  },
  READY_TO_DOWNLOAD: {
    LABEL: 'Ready to Download',
    VALUE: 'readyToDownload',
  },
  ERROR: {
    LABEL: 'Error',
    VALUE: 'error',
  },
}

export const exProfileData = {
  banner: 1,
  companyProfile: 1,
  departments: 1,
  others: 1,
  logo: 1,
  storeDescription: 1,
  token: 1,
  __v: 1,
  _id: 1,
}

export const tooltipData = {
  retailer: {
    general: 'Fill in you general information to the best of your ability so our brands can learn more about you and your store',
    segmentation: 'Select preferred departments to receive most relevant information from your favourite brands',
    documents: 'It is mandatory to upload your Commercial License and VAT Registration details in order to place orders',
    addresses: 'Fill in billing and shipping addresses so you can start placing orders',
    teammates: 'Invite and collaborate with your teammates and improve your workflows',
    referrals: 'Send an invites to your favourite brands and win credits to spend on their latest collections',
    firstorder: 'Place your first order and experience the future of buying from international brands',
  },
  brand: {
    general: 'Fill in your general information to the best of your ability in so our retail partners can learn more about your business',
    segmentation: 'Select your applicable departments and price ranges to segment your Brand on Kingpin.',
    documents: 'It is mandatory to upload your Commercial License & VAT Registration in order to begin receiving orders',
    addresses: 'Here is where you can provide both Billing & Shipping Address details for your business',
    teammates: 'Invite and collaborate with your teammates and improve your workflows',
    firstorder: 'Receive your first Order and experience the future of International wholesale trade.',
    referrals: 'Send an invites to retailers that approach you from the region and get special terms when they order from you',
    social: 'Add your social profiles for more info about your company',
    firstCollection: 'Allow retailers to discover your brand through beautifully curated catalogues. Collections can be made for products that are in-stock or for collecting pre-orders due for later delivery',
  },
}

export const checkListTitle = {
  general: 'Complete general information',
  segmentation: 'Choose your segment',
  documents: 'Upload your documents',
  addresses: 'Complete an address',
  teammates: 'Invite your teammates',
  firstCollection: 'Create your first collection',
  retailerFirstOrder: 'Place an Order',
  brandFirstOrder: 'Receive an Order',
  brandReferrals: 'Invite retailer to join and win credits!',
  retailerReferrals: 'Invite brand to join in and win credits!',
}

export const TOOLKIT_PAGE = {
  WELCOME_TO_KINGPIN: 'welcomeToKingpin',
  PROFILE: 'profile',
  BRANDS_EXPLORE: 'brandsExplore',
  BRAND_PROFILE: 'brandProfile',
  SHOP_PRODUCTS: 'shopProducts',
  WISHLIST: 'wishlist',
  CHECKOUT: 'checkout',
  ORDERS: 'orders',
  TRANSACTIONS: 'transactions',
  DASHBOARD: 'dashboard',
  BRAND_LANDING_PAGE: 'brandLandingPage',
  COLLECTIONS: 'collections',
  COLLECTION_EDIT: 'collectionEdit',
  REFERRALS: 'referrals',
  WALLET: 'wallet',
}

export const HELP_URL = () => Settings.getConfig('VUE_APP_HELP_URL')

export const wishlistAction = {
  ADD_TO_WISHLIST: 'ADD_TO_WISHLIST',
  REMOVE_FROM_WISHLIST: 'REMOVE_FROM_WISHLIST',
  REMOVE_IN_WISHLIST: 'REMOVE_IN_WISHLIST', //   It referes removing function from wishlist page
  ADD_BY_BRAND: 'ADD_BY_BRAND',
}

export const FILE_DOWNLOAD_FORMATS = {
  ZIP: {
    text: 'Images(zip)',
    value: 'zip',
  },
  XLSX_STYLE: {
    text: 'Excel - Style wise',
    value: 'style',
  },
  XLSX_SKU: {
    text: 'Excel - SKU wise',
    value: 'sku',
  },
  PDF: {
    text: 'Invoice',
    value: 'pdf',
  },
  ORDER_DETAILS_PDF: {
    text: 'Order Confirmation',
    value: 'odPdf',
  },
  SHIPMENT_DETAILS_PDF: {
    text: 'Shipment Details',
    value: 'sdPdf',
  },
}

export const EXPORT_ORDERS_OPTIONS = {
  ORDERS_LIST: {
    text: 'Export Orders',
    value: 'list',
  },
  PRODUCTION_FILE: {
    text: 'Export Consolidation File',
    value: 'productionFile',
  },
  PRODUCTION_FILE_WITH_IMAGES: {
    text: 'Export Consolidation File (Include Images)',
    value: 'productionFileWithImages',
  },
}

export const SAMPLE_PRODUCT_SHEET = 'SampleProductSheet'

export const MARKUP_FILTER_OPTIONS = {
  'Under 2.5': {
    UPPER_LIMIT: 2.5,
    LOWER_LIMIT: 0,
  },
  '2.5 - 2.8': {
    UPPER_LIMIT: 2.8,
    LOWER_LIMIT: 2.5,
  },
  '2.8 - 3.1': {
    UPPER_LIMIT: 3.1,
    LOWER_LIMIT: 2.8,
  },
  '3.1+': {
    UPPER_LIMIT: 100,
    LOWER_LIMIT: 3.1,
  },
}

export const PRODUCTS_VIEW = {
  COMPACT_GRID_VIEW: 'compact-grid-view',
  GRID_VIEW: 'grid-view',
}

export const PRODUCTS_ERROR_MESSAGE = 'Your collection upload file contains errors. We have sent the review to your email. Please fix the errors and upload the collection file again.'

export const NAV_ITEM_ID = {
  DASHBOARD: 'dashboard',
  WISHLIST: 'wishlist',
  CHECKOUT: 'checkout',
  EXPLORE: 'explore',
  COLLECTIONS: 'collections',
  ORDERS: 'orders',
  SHIPMENTS: 'shipments',
  CONNECTIONS: 'connections',
  SELECTIONS: 'selections',
  PROFILE: 'profile',
  MESSAGES: 'messages',
  ANALYTICS: 'analytics',
  REFERRALS: 'referrals',
  DOWNLOADS: 'downloads',
  HELP: 'help',
  KNOWLEDGE_CENTER: 'knowledge_center',
  KINGPIN_ACADEMY: 'kingpin_academy',
  SALES_ANALYTICS: 'sales_analytics',
  LEAD_AI: 'leads_ai',
  INTEGRATION_METRICS: 'integration-metrics',
  RETAILER_AI: 'retailer_ai',
}

export const FILE_TYPES = constants.FILE_TYPES

export const TRANSACTION_PAY_LIMIT = 15000

export const UPLOAD_COLLECTION_LOGO_FILE_TYPES = ['jpg', 'png', 'jpeg', 'svg']
export const UPLOAD_CATALOG_FILE_TYPES = ['xlsx', 'zip']

// KP-3919: brand's own catalogue assets on a collection.
// Add-on extensions are restricted to types the Downloads tray already knows
// (backend DOWNLOAD_FILE_TYPES enum).
export const UPLOAD_BRAND_CATALOG_FILE_TYPES = ['pdf', 'ppt', 'pptx', 'html']
export const UPLOAD_BRAND_CATALOG_ADDON_FILE_TYPES = ['ppt', 'pptx', 'xls', 'xlsx', 'pdf', 'csv', 'zip', 'html']
// Mirrors the server schema's maxItems per section.
export const UPLOAD_BRAND_CATALOG_MAX_FILES = 10
// Server-side FILE_TYPES keys (mirror monorepo kingpin-utils FILE_TYPES —
// the published frontend utils package does not carry them yet).
export const BRAND_CATALOG_PDF_FILE_TYPE = 'collection-catalog-pdf'
export const BRAND_CATALOG_ADDON_FILE_TYPE = 'collection-catalog-addon'

export const PORTAL_LINK = 'https://www.kingpin.global/'

export const CREDIT_APPLICATION_UPPER_LIMIT = 30000

export const VUE_EDITOR_DEFAULT_EDIT_OPTIONS = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic', 'underline', 'strike'],
  [
    { align: '' },
    { align: 'center' },
    { align: 'right' },
    { align: 'justify' },
  ],
  ['blockquote', 'code-block'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ color: [] }, { background: [] }],
  ['link'],
]

export const COLLECTION_STATUS_TOOLTIP = {
[COLLECTION_STATUS.NEW.VALUE]: 'Collection is created, add products to proceed to the next step',
[COLLECTION_STATUS.IN_REVIEW.VALUE]: 'Our team is reviewing the catalog and will approve it or reach you shortly',
[COLLECTION_STATUS.LIVE.VALUE]: 'Collection is published and available for placing orders',
[COLLECTION_STATUS.EXPIRED.VALUE]: 'The order deadline for this collection has passed',
}

export const IMAGE_COMPRESSER = {
  size: 4, // the max size in MB, defaults to 2MB
  quality: 0.75, // the quality of the image, max is 1,
  maxWidth: 1920,
  maxHeight: 1920,
  resize: true,
  rotate: false,
}

export const wholesalePrices = [
  'Under $25',
  '$26 - $50',
  '$51 - $100',
  '$101 - $250',
  '$250+',
]

export const retailPrices = [
  'Under $25',
  '$26 - $100',
  '$101 - $250',
  '$251 - $500',
  '$500+',
]

export const TABS = {
  ALL: 'all',
  MARKETPLACE: 'marketplace',
  DIRECT: 'direct',
}

export const API_METHODS = {
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  GET: 'get',
  DELETE: 'delete',
}

export const htmlToPdfOptions = {
    margin: 1,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
}

export const marketplaceAccessDeniedMessage = "You can't access the marketplace"

export const CONNECTION_TABS = constants.BRAND_ACCESS

export const VUE_FLATPICKR_MONTH_CONFIG = {
  plugins: [
    new MonthSelectPlugin({
      dateFormat: KP_MONTH_FORMAT.CONFIG,
      altFormat: KP_MONTH_FORMAT.CONFIG,
      shorthand: true,
    }),
  ],
}
// Used for concating date in Requested Delivery Date and Expected Delivery Date
export const MONTH_START_DATE = '01/'

export const CART_PRODUCTS_SEARCH_FIELDS = [
  'name',
  'department',
  'category',
  'subCategory',
  'uniqueId',
  'styleCode',
]

export const CART_PRODUCTS_SEARCH_ITEMS_FIELDS = ['color', 'colorFamily', 'sku']

export const USER_ROLES = {
  ENTITYADMIN: 'entityAdmin',
  SALESMANAGER: 'salesManager',
  SALESREPRESENTATIVE: 'salesRepresentative',
  KINGPINADMIN: 'kingpinAdmin',
}

export const USER_ROLES_LABEL = {
  [USER_ROLES.ENTITYADMIN]: 'Entity Admin',
  [USER_ROLES.SALESMANAGER]: 'Sales Manager',
  [USER_ROLES.SALESREPRESENTATIVE]: 'Sales Representative',
  [USER_ROLES.KINGPINADMIN]: 'Kingpin Admin',
}

export const availableCurrencies = Object.keys(CURRENCY_CONVERSIONS)

export const searchBarPlaceholderText = 'Search by products, style code'

export const CART_EXPORT_MODAL_ID = 'cart_export_modal'

export const MULTIPLE_CART_EXPORT_MODAL_ID = 'multiple_cart_export_modal'

export const FLAG_CONSTANTS = {
  RETAILER_AI: 'kp_1211_retailer_ai',
  IS_MULTIPLE_CART_VALIDATION_FIX_ENABLED: 'kp_1119_multiple_cart_fix',
  DOWNLOAD_COLLECTION_WITH_ERRORS: 'kp_1187_process_images_refactor',
  PRODUCT_EDIT: 'kp_939_product_edit',
  TRANSACTION_CURRENCY: 'enable_transaction_currency',
  IMPORT_PRICEBOOK_ORDER: 'kp_2199_import_pricebook_order',
  REGISTRATION_FLOW_V2: 'kp_1402_registration_flow_v2',
  DUPLICATE_ORDER: 'kp_2357_duplicate_order',
  NOTIFICATION_PREFERENCES: 'kp_2355_notification_preference',
  KP_2682_MODIFY_ORDER: 'kp_2682_modify_order',
  KP_2629_REMOVE_B2B_AUTH: 'kp_2629_remove_b2b_auth',
  UNIFIED_INVITE_RETAILER: 'kp_unified_platform',
  KP_2829_BULK_SHIPMENT: 'kp_2829_bulk_shipment',
  KP_3377_BULK_SHIPMENT_EXPORT: 'kp_3377_bulk_shipment_export',
  KP_3080_INTERNAL_ANALYTICS: 'kp_3080_internal_analytics',
  // KP-3289: when ON, shared wishlist links open the new V2 (glassmorphic)
  // public wishlist page with filters; when OFF, the legacy public page is used.
  PUBLIC_WISHLIST_V2: 'public_wishlist_v2',
  KP_3462_COLLAPSIBLE_SIDEBAR: 'kp-3462-collapsible-sidebar',
  KP_4128_BULK_REMOVE_SHIPMENT_PRODUCTS: 'kp_4128_bulk_remove_shipment_products',
  // KP-3919: when ON, collections take multiple brand-catalogue files through
  // browser-direct multipart upload and Download Collection uses the picker
  // that delivers them as one structured ZIP. When OFF, every surface behaves
  // exactly as it did before KP-3919: the single-file upload controls and the
  // plain "Download Excel" modal, with no download button on the cards.
  KP_3919_BRAND_CATALOGUE_FILES: 'kp_3919_brand_catalogue_files',
  // KP-4363: when ON, a brand can confirm an order a few products at a time
  // ("Confirm selected products" and the line checkboxes). When OFF those are
  // hidden and the order is confirmed in one go, as before KP-4363.
  KP_4363_PARTIAL_ORDER_CONFIRMATION: 'kp_4363_partial_order_confirmation',
}

export const NOTIFICATION_PREFERENCE_OPTIONS = [
  { key: 'default', label: 'Default' },
  { key: 'all', label: 'All' },
  { key: 'none', label: 'None' },
]

export const NOTIFICATION_PREFERENCE_TYPES = [
  { key: 'order', label: 'Order' },
  { key: 'shipment', label: 'Shipment' },
  { key: 'collectionPref', label: 'Collection' },
]

export const PRODUCT_EDIT_VALID_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp']

export const PRODUCT_FIELD_MAP = {
  STYLE_CODE: 'styleCode',
  PARENT_ID: 'uniqueId',
  SHIPPING_START_DATE: 'shippingStartDate',
  SHIPPING_END_DATE: 'shippingEndDate',
  IMAGES: 'images',
  DEPARTMENT: 'department',
  CATEGORY: 'category',
  SUB_CATEGORY: 'subCategory',
  COUNTRY: 'country',
  KEY_STYLES: 'keyStyles',
  GENDER: 'gender',
  STATUS: 'status',
  IS_CARTON: 'isCarton',
  ITEMS: 'items',
}

export const MAX_COLORS_PER_PRODUCT_CARD = 5
export const MAX_COLORS_EXPANDED = 15
